export const environment = {
  production: false,
  name: 'Development',
  staticPrefix: '',
  navbarLogoImageUrl: 'assets/images/zinger-logo.png',
  navbarIconImageUrl: 'assets/images/zinger-icon.png',
  accountPageImageUrl: 'assets/images/emplayZinger.png',
  accountPageFallbackText: 'Hi there',
  loginPageText: 'Make your Business Autonomous with Zinger'
};
